
<script >

export default ({
    name: "size-guide",
    components: {
       
    },

    props: {
        
    },

    computed: {

    },

    mounted() {
       
    },

    data() {
        return {

        }
    },
    methods: {

    }
})
</script>
  
<template>
    
      <div>





    
    <div>
<h3 class="mb-4">GUIDE DES TAILLES FEMME</h3>
</div>
<h5>VÊTEMENT</h5>
<div class=" table-responsive">
    <div class="table-responsive">
        <table border="0" class="table table-bordered " style="font-size: 12px;">
            <tbody>
                <tr>
                    <td style="width:100%">


                       
                            <table class="table table-bordered  w-100">
                                <tbody>
                                    <tr class="rowheading" style="background-color: #000; color: #fff;">
                                        <th scope="col">Taille</th><th class="rowheading" scope="col">34</th><th class="rowheading" scope="col">36</th><th class="rowheading" scope="col">38</th><th class="rowheading" scope="col">40</th><th class="rowheading" scope="col">42</th><th class="rowheading" scope="col">44</th><th class="rowheading" scope="col">46</th><th class="rowheading" scope="col">48</th><th class="rowheading" scope="col">50</th></tr>
                                    <tr>
                                        <td>Poitrine (cm)</td>
                                        <td>82</td>
                                        <td>86</td>
                                        <td>90</td>
                                        <td>94</td>
                                        <td>98</td>
                                        <td>102</td>
                                        <td>106</td>
                                        <td>110</td>
                                        <td>114</td>
                                    </tr>
                                    <tr>
                                    <td>Taille (cm)</td>
                                    <td>64</td>
                                    <td>66</td>
                                    <td>70</td>
                                    <td>74</td>
                                    <td>78</td>
                                    <td>82</td>
                                    <td>86</td>
                                    <td>90</td>
                                    <td>94</td>
                                    </tr>
                                    <tr>
                                    <td>Hanches (cm)</td>
                                    <td>90</td>
                                    <td>94</td>
                                    <td>98</td>
                                    <td>102</td>
                                    <td>106</td>
                                    <td>110</td>
                                    <td>114</td>
                                    <td>118</td>
                                    <td>122<br><br></td>
                                    </tr>
                                </tbody>
                            </table>
                       







<div class="table-responsive"><div class="responsive_table"><table class="table table-bordered w-100" style="font-size: 12px;">
<tbody>
<tr style="background-color: #000; color: #fff;"><th class="rowheading" scope="col">Taille</th><th class="rowheading" scope="col">XS</th><th class="rowheading" scope="col">S</th><th class="rowheading" scope="col">M</th><th class="rowheading" scope="col">L</th><th class="rowheading" scope="col">XL</th><th class="rowheading" scope="col">XXL</th><th class="rowheading" scope="col">XXXL</th><th class="rowheading" scope="col">XXXXL</th></tr>
<tr>
<td>Poitrine (cm)</td>
<td>82</td>
<td>86</td>
<td>90</td>
<td>96</td>
<td>102</td>
<td>108</td>
<td>114</td>
<td>120</td>
</tr>
<tr>
<td>Taille (cm)</td>
<td>62</td>
<td>66</td>
<td>70</td>
<td>76</td>
<td>82</td>
<td>88</td>
<td>94</td>
<td>100</td>
</tr>
<tr>
<td>Hanches (cm)</td>
<td>90</td>
<td>94</td>
<td>98</td>
<td>104</td>
<td>110</td>
<td>116</td>
<td>122</td>
<td>128</td>
</tr>
</tbody>
</table></div></div>
<p></p>
<h5>COMMENT MESURER</h5>
<p class="footnote">* Les tailles indiquées dans le guide des tailles se réfèrent aux mensurations du corps et non aux tailles des vêtements</p>
<h5>CHAUSSURES</h5>
<div class="table-responsive"><div class="responsive_table"><table class="table table-bordered w-100" style="font-size: 12px;">
<tbody>
<tr style="background-color: #000; color: #fff;"><th class="rowheading" scope="col">Taille</th><th scope="col">36</th><th scope="col">37</th><th scope="col">38</th><th scope="col">39</th><th scope="col">40</th><th scope="col">41</th></tr>
<tr>
<td>Longueur pied (cm)</td>
<td>23.4</td>
<td>24.0</td>
<td>24.6</td>
<td>25.3</td>
<td>26</td>
<td>26.6</td>
</tr>
<tr>
<td>Taille (épaisseur)</td>
<td>36/37</td>
<td>38/39</td>
<td>40/41</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>Longueur pied (cm)</td>
<td>24</td>
<td>25.3</td>
<td>26.6</td>
<td></td>
<td></td>
<td></td>
</tr>
</tbody>
</table></div></div>
<p class="footnote">* Les tailles indiquées dans le guide des tailles se réfèrent à la pointure et non à la dimension de la chaussure.</p>
<h5>Soutien-Gorge</h5>
<div class="table-responsive"><div class="responsive_table"><table class="table table-bordered w-100" style="font-size: 12px;">
<tbody>
<tr style="background-color: #000; color: #fff;"><th class="rowheading" scope="col">TOUR DE DOS</th><th scope="col">Taille à</th><th colspan="5" scope="col" style="text-align: center;">Tour de poitrine en cm</th></tr>
<tr>
<td>en cm</td>
<td>commander</td>
<td>Bonnet A</td>
<td>Bonnet B</td>
<td>Bonnet C</td>
<td>Bonnet D</td>
<td>Bonnet E</td>
</tr>
<tr>
<td>63/67</td>
<td>80</td>
<td>77/79</td>
<td>79/81</td>
<td>81/83</td>
<td>83/85</td>
<td>87/89</td>
</tr>
<tr>
<td>68/72</td>
<td>85</td>
<td>82/84</td>
<td>84/86</td>
<td>86/88</td>
<td>88/90</td>
<td>90/92</td>
</tr>
<tr>
<td>73/77</td>
<td>90</td>
<td>87/89</td>
<td>89/91</td>
<td>91/93</td>
<td>93/95</td>
<td>95/97</td>
</tr>
<tr>
<td>78/82</td>
<td>95</td>
<td>92/94</td>
<td>94/96</td>
<td>96/98</td>
<td>98/100</td>
<td>100/102</td>
</tr>
<tr>
<td>83/87</td>
<td>100</td>
<td>97/101</td>
<td>99/101</td>
<td>101/103</td>
<td>103/105</td>
<td>105/107</td>
</tr>
<tr>
<td>88/92</td>
<td>105</td>
<td>102/104</td>
<td>104/106</td>
<td>106/108</td>
<td>108/110</td>
<td>110/112</td>
</tr>
</tbody>
</table></div></div>
<div class="table-responsive"><div class="responsive_table"><table class="table table-bordered w-100" style="font-size: 12px;">
<tbody>
<tr style="background-color: #000; color: #fff;"><th class="rowheading" rowspan="2" scope="col" style="text-align: left;">Taille à commander</th><th scope="col">36</th><th scope="col">38</th><th scope="col">40</th><th scope="col">42</th><th scope="col">44</th><th scope="col">46</th></tr>
<tr>
<td>Taille 0</td>
<td>Taille 1</td>
<td>Taille 2</td>
<td>Taille 3</td>
<td>Taille 4</td>
<td>Taille 5</td>
</tr>
<tr>
<td>Tour de taille (cm)</td>
<td>53 à 57</td>
<td>58 à 62</td>
<td>63 à 67</td>
<td>68 à 72</td>
<td>73 à 77</td>
<td>78 à 82</td>
</tr>
<tr>
<td>Tour de bassin (cm)</td>
<td>87 à 91</td>
<td>92 à 96</td>
<td>97 à 101</td>
<td>102 à 106</td>
<td>107 à 111</td>
<td>112 à 116</td>
</tr>
</tbody>
</table></div></div>
</td>
<td><img height="400" src="@/assets/images/mannequin-fm.jpeg" width="266"></td>
</tr>
</tbody>
</table></div></div>
<div>
<h3 class="mb-4">GUIDE DES TAILLES HOMME</h3>
</div>
<h5>VÊTEMENT</h5>
<div class="table-responsive"><div class="responsive_table"><table border="0" class="table table-bordered w-100">
<tbody>
<tr>
<td>
<h5>OUTWEAR, T-SHIRTS, POLOS ET PULLS</h5>
<div class="table-responsive"><div class="responsive_table"><table class="table table-bordered w-100" style="font-size: 12px;">
<tbody>
<tr style="background-color: #000; color: #fff;"><th class="rowheading" scope="col">Taille</th><th scope="col">S</th><th scope="col">M</th><th scope="col">L</th><th scope="col">XL</th><th scope="col">XXL</th><th scope="col">XXXL</th><th scope="col">XXXXL</th></tr>
<tr>
<td>Tour de Poitrine (cm)</td>
<td>91-96</td>
<td>96-101</td>
<td>101-107</td>
<td>107-112</td>
<td>112-117</td>
<td>117-122</td>
<td>122-127</td>
</tr>
</tbody>
</table></div></div>
<h5>COSTUME, BLAZER</h5>
<div class="table-responsive"><div class="responsive_table"><table class="table table-bordered w-100" style="font-size: 12px;">
<tbody>
<tr style="background-color: #000; color: #fff;"><th class="rowheading" scope="col">Taille</th><th scope="col">46</th><th scope="col">48</th><th scope="col">50</th><th scope="col">52</th><th scope="col">54</th><th scope="col">56</th><th scope="col">58</th><th scope="col">60</th><th scope="col">62</th></tr>
<tr>
<td>Tour de Poitrine (cm)</td>
<td>88-90</td>
<td>92-94</td>
<td>96-98</td>
<td>100-102</td>
<td>104-106</td>
<td>108-110</td>
<td>112-114</td>
<td>116-118</td>
<td>120-122</td>
</tr>
</tbody>
</table></div></div>
<h5>PANTALONS DE COSTUME</h5>
<div class="table-responsive"><div class="responsive_table"><table class="table table-bordered w-100" style="font-size: 12px;">
<tbody>
<tr style="background-color: #000; color: #fff;"><th class="rowheading" scope="col">Taille</th><th scope="col">40</th><th scope="col">42</th><th scope="col">44</th><th scope="col">46</th><th scope="col">48</th><th scope="col">50</th><th scope="col">52</th><th scope="col">54</th><th scope="col">56</th><th scope="col">58</th></tr>
<tr class="pinkrow">
<td><strong>Tour de Poitrine (cm)</strong><strong></strong></td>
<td>91-92</td>
<td>95-96</td>
<td>99-100</td>
<td>103-104</td>
<td>107-108</td>
<td>111-112</td>
<td>115-116</td>
<td>119-120</td>
<td>123-124</td>
<td>127-128</td>
</tr>
</tbody>
</table></div></div>
<h5>CHEMISE</h5>
<div class="table-responsive"><div class="responsive_table"><table class="table table-bordered w-100" style="font-size: 12px;">
<tbody>
<tr style="background-color: #000; color: #fff;"><th class="rowheading" scope="col">Taille</th><th scope="col">S</th><th scope="col">M</th><th scope="col">L</th><th scope="col">XL</th><th scope="col">XXL</th><th scope="col">XXXL</th></tr>
<tr class="pinkrow">
<td><strong>EU</strong></td>
<td>38</td>
<td>40</td>
<td>42</td>
<td>44</td>
<td>46</td>
<td>48</td>
</tr>
<tr>
<td>Tour de Poitrine (cm)</td>
<td>91-96</td>
<td>96-101</td>
<td>101-107</td>
<td>107-112</td>
<td>112-117</td>
<td>117-122</td>
</tr>
<tr>
<td>Cou (cm)</td>
<td>37-38</td>
<td>39-40</td>
<td>41-42</td>
<td>43-44</td>
<td>45-46</td>
<td>47-48</td>
</tr>
</tbody>
</table></div></div>
<h5>JEANS, PANTALONS</h5>
<div class="table-responsive"><div class="responsive_table"><table class="table table-bordered w-100" style="font-size: 12px;">
<tbody>
<tr style="background-color: #000; color: #fff;"><th class="rowheading" scope="col">EU</th><th scope="col">36</th><th scope="col">38</th><th scope="col">40</th><th scope="col">42</th><th scope="col">44</th><th scope="col">46</th><th scope="col">48</th><th scope="col">50</th><th scope="col">52</th><th scope="col">54</th></tr>
<tr>
<td>Taille (cm)</td>
<td>72-73</td>
<td>76-77</td>
<td>80-81</td>
<td>84-85</td>
<td>88-89</td>
<td>92-93</td>
<td>96-97</td>
<td>100-103</td>
<td>106-109</td>
<td>112-115</td>
</tr>
<tr>
<td>Hanches (cm)</td>
<td>91-92</td>
<td>95-96</td>
<td>99-100</td>
<td>103-104</td>
<td>107-108</td>
<td>111-112</td>
<td>115-116</td>
<td>119-120</td>
<td>123-124</td>
<td>127-128</td>
</tr>
</tbody>
</table></div></div>
<h5>CHAUSSURES</h5>
<div class="table-responsive"><div class="responsive_table"><table class="table table-bordered w-100" style="font-size: 12px;">
<tbody>
<tr style="background-color: #000; color: #fff;"><th class="rowheading" scope="col">EU</th><th scope="col">39</th><th scope="col">40</th><th scope="col">41</th><th scope="col">42</th><th scope="col">43</th><th scope="col">44</th><th scope="col">45</th></tr>
<tr>
<td><strong>UK</strong></td>
<td>5</td>
<td>6</td>
<td>7</td>
<td>8</td>
<td>9</td>
<td>10</td>
<td>11</td>
</tr>
<tr class="pinkrow">
<td><strong>USA</strong></td>
<td>6</td>
<td>7</td>
<td>8</td>
<td>9</td>
<td>10</td>
<td>11</td>
<td>12</td>
</tr>
<tr class="pinkrow">
<td><strong>Longueur du pied (cm)</strong></td>
<td>25.3</td>
<td>25.8</td>
<td>26.4</td>
<td>27</td>
<td>27.6</td>
<td>28.3</td>
<td>28.9</td>
</tr>
</tbody>
</table></div></div>
</td>
<td><img height="400" src="@/assets/images/yesman.jpg"  width="266"><br><br></td>
</tr>
</tbody>
</table></div></div>
<div>
<h5>GUIDE DES TAILLES ENFANT</h5>
</div>
<div class="table-responsive"><div class="responsive_table"><table class="table table-bordered w-100">
<thead>
<tr class="rowheading" style="background-color: #000; color: #fff;"><th class="tg-0lax">Taille</th><th class="tg-0lax">2ans</th><th class="tg-0lax">4ans</th><th class="tg-0lax">6ans</th><th class="tg-0lax">8ans</th><th class="tg-0lax">10ans</th><th class="tg-0lax">12ans</th><th class="tg-0lax">14ans</th></tr>
</thead>
<tbody>
<tr>
<td class="tg-0lax">Hauteur (cm)</td>
<td class="tg-0lax">98</td>
<td class="tg-0lax">110</td>
<td class="tg-0lax">120</td>
<td class="tg-0lax">130</td>
<td class="tg-0lax">140</td>
<td class="tg-0lax">152</td>
<td class="tg-0lax">164</td>
</tr>
<tr>
<td class="tg-0lax">Tour de poitrine (cm)</td>
<td class="tg-0lax">55</td>
<td class="tg-0lax">59</td>
<td class="tg-0lax">64</td>
<td class="tg-0lax">69</td>
<td class="tg-0lax">74</td>
<td class="tg-0lax">79</td>
<td class="tg-0lax">84</td>
</tr>
<tr>
<td class="tg-0lax">Taille (cm)</td>
<td class="tg-0lax">52</td>
<td class="tg-0lax">55</td>
<td class="tg-0lax">58</td>
<td class="tg-0lax">62</td>
<td class="tg-0lax">65</td>
<td class="tg-0lax">68</td>
<td class="tg-0lax">71</td>
</tr>
<tr>
<td class="tg-0lax">Hanche (cm)</td>
<td class="tg-0lax">57</td>
<td class="tg-0lax">61</td>
<td class="tg-0lax">66</td>
<td class="tg-0lax">71</td>
<td class="tg-0lax">76</td>
<td class="tg-0lax">81</td>
<td class="tg-0lax">86</td>
</tr>
<tr>
<td class="tg-0lax">Entre jambe (cm)</td>
<td class="tg-0lax">40</td>
<td class="tg-0lax">46</td>
<td class="tg-0lax">52</td>
<td class="tg-0lax">59</td>
<td class="tg-0lax">66</td>
<td class="tg-0lax">71</td>
<td class="tg-0lax">76</td>
</tr>
</tbody>
</table></div></div>
<div>
<h5>GUIDE DES TAILLES BEBE</h5>
</div>
<div class="table-responsive"><div class="responsive_table"><table class="table table-bordered w-100">
<thead>
<tr class="rowheading" style="background-color: #000; color: #fff;"><th class="tg-0lax">Taille Bébé</th><th class="tg-0lax">3 – 6 mois</th><th class="tg-0lax">6 – 9 mois</th><th class="tg-0lax">9 – 12 mois</th><th class="tg-0lax">12 – 18 mois</th><th class="tg-0lax">18 – 24 mois</th><th class="tg-0lax">24 – 36 ans</th></tr>
</thead>
<tbody>
<tr>
<td class="tg-0lax">Hauteur (cm)</td>
<td class="tg-0lax">68</td>
<td class="tg-0lax">74</td>
<td class="tg-0lax">80</td>
<td class="tg-0lax">86</td>
<td class="tg-0lax">92</td>
<td class="tg-0lax">98</td>
</tr>
<tr>
<td class="tg-0lax">Tour de poitrine (cm)</td>
<td class="tg-0lax">45</td>
<td class="tg-0lax">47</td>
<td class="tg-0lax">49</td>
<td class="tg-0lax">51</td>
<td class="tg-0lax">53</td>
<td class="tg-0lax">55</td>
</tr>
<tr>
<td class="tg-0lax">Taille (cm)</td>
<td class="tg-0lax">46</td>
<td class="tg-0lax">48</td>
<td class="tg-0lax">49</td>
<td class="tg-0lax">50</td>
<td class="tg-0lax">51</td>
<td class="tg-0lax">52</td>
</tr>
<tr>
<td class="tg-0lax">Hanche (cm)</td>
<td class="tg-0lax">47</td>
<td class="tg-0lax">49</td>
<td class="tg-0lax">51</td>
<td class="tg-0lax">53</td>
<td class="tg-0lax">55</td>
<td class="tg-0lax">57</td>
</tr>
<tr>
<td class="tg-0lax">Entre jambe (cm)</td>
<td class="tg-0lax">24</td>
<td class="tg-0lax">27</td>
<td class="tg-0lax">30</td>
<td class="tg-0lax">33</td>
<td class="tg-0lax">37</td>
<td class="tg-0lax">40</td>
</tr>
<tr>
<td class="tg-0lax">Poids (Kg)</td>
<td class="tg-0lax">7.5</td>
<td class="tg-0lax">8</td>
<td class="tg-0lax">9.5</td>
<td class="tg-0lax">11</td>
<td class="tg-0lax">12.5</td>
<td class="tg-0lax">14</td>
</tr>
<tr>
<td class="tg-0lax">Tour de la tête</td>
<td class="tg-0lax">45</td>
<td class="tg-0lax">46</td>
<td class="tg-0lax">47</td>
<td class="tg-0lax">48</td>
<td class="tg-0lax">49</td>
<td class="tg-0lax">50</td>
</tr>
<tr>
<td class="tg-0lax">Longueur du pied (cm)</td>
<td class="tg-0lax">11</td>
<td class="tg-0lax">12</td>
<td class="tg-0lax">13</td>
<td class="tg-0lax">14</td>
<td class="tg-0lax">15</td>
<td class="tg-0lax">15,5</td>
</tr>
<tr>
<td class="tg-0lax">pointure EU</td>
<td class="tg-0lax">18</td>
<td class="tg-0lax">19/20</td>
<td class="tg-0lax">21</td>
<td class="tg-0lax">22/23</td>
<td class="tg-0lax">24</td>
<td class="tg-0lax">25</td>
</tr>
</tbody>
</table>

</div></div> 



</div>  

</template>

<style scoped>

</style>
  